import { Shield, Percent, Headphones, ArrowRight } from "lucide-react";

export const TipsSection = () => {
  const tips = [
    {
      icon: Shield,
      title: "Secure Platform"
    },
    {
      icon: Percent,
      title: "0% Platform Fee"
    },
    {
      icon: Headphones,
      title: "Expert Support"
    }
  ];

  return (
    <section className="pt-6 pb-12 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 max-w-7xl">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
          {tips.map((tip, index) => {
            const Icon = tip.icon;
            return (
              <div 
                key={index} 
                className="rounded-lg p-4 sm:p-6 flex items-center gap-3 sm:gap-4 hover:shadow-md transition-shadow cursor-pointer group bg-[#ecfcf7]"
              >
                <div className="rounded-full p-2.5 sm:p-3 flex-shrink-0 bg-[#a3f7c7]">
                  <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-gray-900" />
                </div>
                <span className="text-gray-900 font-semibold text-base sm:text-lg flex-1">
                  {tip.title}
                </span>
                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 text-gray-900 flex-shrink-0 group-hover:translate-x-1 transition-transform" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
